import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { API } from "../../../API";
import { isAutheticated } from "../../auth/authhelper";
import Footer from "../Footer";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import getSymbolFromCurrency from "currency-symbol-map";

const Order = () => {
  const { token } = isAutheticated();
  const { status } = useParams();
console.log("llll",token)
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currency, setCurrency] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showData, setShowData] = useState([]);

  // 🔹 Get user settings like currency
  // useEffect(() => {
  //   async function fetchSettings() {
  //     try {
  //       const res = await axios.get(`${API}/api/user`, {
  //         headers: { Authorization: `Bearer ${token}` }
  //       });
  //       setCurrency(res.data.data.settings.currency);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  //   fetchSettings();
  // }, [token]);

  // 🔹 Fetch Orders by Status (new, processing, dispatched...)
  useEffect(() => {
    async function loadOrders() {
      setIsLoading(true);
      try {
        const res = await axios.get(`${API}/api/order/status/${status}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setData(res.data.orders || []); // expects {data:[...orders]}
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    }

    loadOrders();
  }, [token, status]);

  // 🔹 Pagination logic
  useEffect(() => {
    const indexOfLast = currentPage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    setShowData(data.slice(indexOfFirst, indexOfLast));
  }, [data, currentPage, itemPerPage]);

  // 🔹 First letter capital
  const StatusTitle = status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">

          {/* Header */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex justify-content-between">
                <h4>Order Management - {StatusTitle} Orders</h4>

                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">SoComOTT</Link>
                  </li>
                  <li className="breadcrumb-item active">Orders - {StatusTitle}</li>
                </ol>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">

                  {/* Entry Count */}
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label>
                        Show{" "}
                        <select
                          className="custom-select custom-select-sm w-auto"
                          value={itemPerPage}
                          onChange={(e) => setItemPerPage(e.target.value)}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>{" "}
                        entries
                      </label>
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive">
                    <table className="table table-centered mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Order ID</th>
                          <th>Name</th>
                          <th>Amount</th>
                          <th>Placed On</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {!isLoading &&
                          showData.map((item) => (
                            <tr key={item._id}>
                              <td>{item.orderID}</td>
                              <td>{item.shippingInfo?.Name}</td>
                              <td>
                                {/* {getSymbolFromCurrency(currency)}  */}
                                ${item.total_amount}
                              </td>
                              <td>
                                {new Date(item.updatedAt)
                                  .toDateString()
                                  .split(" ")
                                  .slice(1)
                                  .join(" ")}
                              </td>
                              <td>
                                <span className="badge badge-success">
                                  {StatusTitle}
                                </span>
                              </td>
                              <td>
                                <Link to={`/orders/${status}/${item._id}`}>
                                  <button className="btn btn-primary btn-sm">
                                    View
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          ))}

                        {!isLoading && data.length === 0 && (
                          <tr>
                            <td colSpan="6" className="text-center">
                              <h5>No Data Available</h5>
                            </td>
                          </tr>
                        )}

                        {isLoading && (
                          <tr>
                            <td colSpan="6" className="text-center">
                              <ClipLoader loading={isLoading} size={24} />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="row mt-3">
                    <div className="col-md-6">
                      <p>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                        {data.length} entries
                      </p>
                    </div>

                    <div className="col-md-6 text-right">
                      <ul className="pagination">
                        {/* Previous */}
                        <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage - 1)}
                          >
                            Previous
                          </button>
                        </li>

                        {/* Current */}
                        <li className="page-item active">
                          <button className="page-link">{currentPage}</button>
                        </li>

                        {/* Next */}
                        <li
                          className={`page-item ${
                            currentPage * itemPerPage >= data.length && "disabled"
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Order;
